module.exports = __webpack_public_path__ + "assets/d_visa-134651.svg";